/**
 * HTML 消毒工具
 * 防止 XSS 攻击
 */
import DOMPurify from 'dompurify'

// 配置 DOMPurify
const purifyConfig = {
  ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'span', 'br', 'div', 'img'],
  ALLOWED_ATTR: ['class', 'style', 'src', 'alt'],
  ALLOW_DATA_ATTR: false,
  // 禁止 javascript: 和 data: URL
  ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i
}

/**
 * 消毒 HTML 内容
 * @param {string} html - 原始 HTML
 * @returns {string} 安全的 HTML
 */
export function sanitizeHtml(html) {
  if (!html) return ''
  return DOMPurify.sanitize(html, purifyConfig)
}

/**
 * 转义 HTML 特殊字符（纯文本消毒）
 * @param {string} text - 原始文本
 * @returns {string} 转义后的文本
 */
export function escapeHtml(text) {
  if (!text) return ''
  const div = document.createElement('div')
  div.textContent = text
  return div.innerHTML
}

/**
 * 验证并消毒 URL
 * 只允许 http/https 协议
 * @param {string} url - 原始 URL
 * @returns {string} 安全的 URL 或空字符串
 */
export function sanitizeUrl(url) {
  if (!url) return ''

  // 去除首尾空白
  const trimmed = url.trim()

  // 只允许 http 和 https 协议
  if (!/^https?:\/\//i.test(trimmed)) {
    // 如果是相对路径或没有协议，检查是否有危险字符
    if (/^(javascript|data|vbscript):/i.test(trimmed)) {
      console.warn('危险 URL 被拦截:', trimmed.substring(0, 50))
      return ''
    }
    // 相对路径允许通过
    return trimmed
  }

  return trimmed
}

/**
 * 创建安全的图片点击处理器（避免 onclick 注入）
 * @param {string} imageUrl - 图片 URL
 * @returns {Function} 点击处理函数
 */
export function createSafeImageClickHandler(imageUrl) {
  const safeUrl = sanitizeUrl(imageUrl)
  if (!safeUrl) return () => {}

  return () => {
    window.open(safeUrl, '_blank', 'noopener,noreferrer')
  }
}

export default {
  sanitizeHtml,
  escapeHtml,
  sanitizeUrl,
  createSafeImageClickHandler
}
